import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-fuelInput-control-label-view, [app-fuelInput-control-label-view]',
  templateUrl: './fuelInput-control-label-view.component.html',
  styleUrls: ['./fuelInput-control-label-view.component.scss']
})
export class FuelInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
